<template lang="pug">
  ods-form.the-b2b-change-password(
    :model='form',
    :rules='validationRules',
    ref='changePasswordForm',
    :hide-required-asterisk="true")
    div
      div(align='center')
        img(:src='getImgUrl()' width='70%')
      h1.the-b2b-change-password__title {{ $t('profile.password.change_password') }}
      ods-form-item(ref='formItemNewPass' :label='$t("profile.password.change_password_form.new_password.label")' prop='newpassword')
        ods-input(v-model='form.newpassword' show-password type='password' :placeholder='$t("profile.password.change_password_form.new_password.placeholder")' @input='passwordFormHasChanged' auto-complete='off')
      ods-form-item(ref='formItemRepeatNewPass' :label='$t("profile.password.change_password_form.confirm_password.label")' prop='repeatnewpassword' class="ods-mb-10")
        ods-input(v-model='form.repeatnewpassword' show-password type='password' :placeholder='$t("profile.password.change_password_form.confirm_password.placeholder")' @input='passwordFormHasChanged' auto-complete='off')
    div.the-b2b-change-password__actions
      ods-button(v-if='!hideCancelButton' type='neutral' @click='resetForm()')
        | {{ $t('buttons.btnClear') }}
      ods-button(type='primary' @click='savePassword' round :disabled='saveButtonDisabled').is-shadow
        | {{ $t('buttons.btnSaveChanges') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/components/shared/Utils'
import router from '@/router/index'
import fn from '../../utils/functions'
export default {
  name: 'b2b-change-password',
  mixins: [Utils],
  props: {
    css: {
      type: String
    },
    logo: {
      type: String
    },
    next: {
      type: String
    },
    localproject: {
      type: String
    },
    logomenu: {
      typlogomenue: String
    }
  },
  data () {
    return {
      username: null,
      urlUser: null,
      saveButtonDisabled: true,
      hideCancelButton: true,
      oldpassword: null,
      form: {
        newpassword: null,
        repeatnewpassword: null
      },
      rules: {
        newpassword: [
          {
            validator: (rule, value, callback) => {
              if (
                (this.form.repeatnewpassword &&
                    this.form.repeatnewpassword !== '') &&
                (!value)
              ) {
                callback(
                  new Error(this.$t('msg_generics.field_required'))
                )
              } else {
                callback()
              }
            },
            trigger: 'change'
          },
          {
            min: 10,
            message: this.$t('msg_generics.min_num_character', { min: 10 }),
            trigger: 'change'
          },
          {
            max: 64,
            message: this.$t('msg_generics.max_num_character', { max: 64 }),
            trigger: 'change'
          },
          {
            pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#\$%\^&\*_=\+-/])[A-Za-z\d!@#\$%\^&\*_=\+-/]{10,64}$/, // eslint-disable-line
            message: this.$t('profile.password.rules_form.pattern'),
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value && value === this.oldpassword) {
                callback(
                  new Error(this.$t('profile.password.rules_form.pass_eqaul_newpass'))
                )
              } else {
                callback()
              }
            },
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value && value != '') { // eslint-disable-line
                const forbiddenWords = [
                  '01234587',
                  '12345679',
                  'Xxxxxxxxx',
                  'Yyyyyyyyy',
                  'Password',
                  'Administrador',
                  'Administ',
                  '00000000',
                  '11111111'
                ]
                if (forbiddenWords.includes(value)) {
                  callback(
                    new Error(this.$t('profile.password.rules_form.fobidden_words'))
                  )
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value && value != '' && value === this.username) { // eslint-disable-line
                callback(
                  new Error(this.$t('profile.password.rules_form.pass_equal_user'))
                )
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        repeatnewpassword: [
          {
            validator: (rule, value, callback) => {
              if (
                (this.form.repeatnewpassword &&
                    this.form.repeatnewpassword !== '') &&
                (!value)
              ) {
                callback(
                  new Error(this.$t('msg_generics.field_required'))
                )
              } else {
                callback()
              }
            },
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value && value !== this.form.newpassword) {
                callback(new Error(this.$t('profile.password.rules_form.newpass_not_equals_confirmation')))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      validationRules: {}
    }
  },

  computed: {
    ...mapGetters(['loadmenulogo', 'urlIn'])
  },

  methods: {
    ...mapActions([
      'modifyPassword',
      'loadLogoMenuAction'
    ]),

    getImgUrl () {
      if (this.loadmenulogo) {
        return require('../../assets/images/projects/' + this.loadmenulogo)
      } else {
        return ''
      }
    },
    clearFormData () {
      this.form.newpassword = null
      this.form.repeatnewpassword = null
    },

    async resetForm () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        this.$refs.changePasswordForm.resetFields()
        delete this.$refs.changePasswordForm.rules.newpassword
        delete this.$refs.changePasswordForm.rules.repeatnewpassword
        this.saveButtonDisabled = true
        this.hideCancelButton = true
      } finally {
        load.close()
      }
    },

    passwordFormHasChanged () {
      if (
        !this.oldpassword &&
        !this.form.newpassword &&
        !this.form.repeatnewpassword
      ) {
        delete this.$refs.changePasswordForm.rules.newpassword
        this.$refs.formItemNewPass.resetField()
        delete this.$refs.changePasswordForm.rules.repeatnewpassword
        this.$refs.formItemRepeatNewPass.resetField()
      } else {
        this.$refs.changePasswordForm.rules.newpassword = this.rules.newpassword
        this.$refs.changePasswordForm.rules.repeatnewpassword = this.rules.repeatnewpassword
        this.$refs.changePasswordForm.validate().catch(error => false) // eslint-disable-line
      }
      this.formHasChanged()
    },

    formHasChanged () {
      const dirty =
        !!(this.oldpassword ||
        this.form.newpassword ||
        this.form.repeatnewpassword)
      this.saveButtonDisabled = !dirty
      this.hideCancelButton = !dirty
    },

    async savePassword () {
      this.passwordFormHasChanged()
      const formValid = await this.$refs.changePasswordForm
        .validate()
        .catch(error => false) // eslint-disable-line
      if (!formValid) {
        this.$notify({
          title: this.$t('profile.password.rules_form.validation_error'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
        return
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const params = {}
        if (
          this.form.newpassword ||
          this.oldpassword ||
          this.form.repeatnewpassword
        ) {
          params.password = {
            newPassword: this.form.newpassword,
            oldPassword: this.oldpassword,
            repeatNewPassword: this.form.repeatnewpassword
          }
        }
        await this.modifyPassword(params)
        this.$notify({
          title: this.$t('profile.notify.changes_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        this.resetForm()
        if (this.urlUser !== null && this.urlUser !== undefined) {
          switch (this.urlUser) {
            case 'quiron':
              router.push({
                name: 'loginquiron'
              })
              break
            case 'hipoges':
              router.push({
                name: 'loginhipoges'
              })
              break
            case 'ohla':
              router.push({
                name: 'loginohl'
              })
              break
            case 'redelectrica':
              router.push({
                name: 'loginree'
              })
              break
            case 'renfe':
              router.push({
                name: 'loginrenfe'
              })
              break
            case 'EECG':
              router.push({
                name: 'loginufgas'
              })
              break
            case 'CanalSA':
              router.push({
                name: 'logincanal'
              })
              break
            case 'lyntia':
              router.push({
                name: 'loginlyntia'
              })
              break
            case 'correosexpress':
              router.push({
                name: 'logincorreos'
              })
              break
            case 'telefonica':
              router.push({
                name: 'logintee'
              })
              break
            case 'accionaenergia':
              router.push({
                name: 'loginaccionaenergia'
              })
              break
            case 'vocento':
              router.push({
                name: 'loginvocento'
              })
              break
            case 'red.es':
              router.push({
                name: 'loginredes'
              })
              break
            default:
              router.push({
                name: 'login'
              })
              break
          }
        } else {
          router.push({ name: 'login' })
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 404:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error, 10000)
    }
  },

  async created () {
    this.username = this.$store.getters.activeUser.data.username
    this.oldpassword = this.$route.params.password

    console.log('this.oldpassword: ', this.oldpassword)
    console.log('this.username: ', this.username)
    if ((!this.oldpassword || this.oldpassword === undefined)) {
      if (this.urlIn == null) {
        router.push({ name: 'login' }).catch(error => console.log('push exception', error))
      } else {
        router.push({ name: fn.assignLoginName(this.urlIn) }).catch(error => console.log('push exception', error))
      }
    }

    this.urlUser = this.$route.params.urlIn

    this.clearFormData()
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      if (this.$refs.changePasswordForm) {
        this.$refs.changePasswordForm.clearValidate()
      }

      await this.loadLogoMenuAction(this.loadmenulogo)
    } catch (error) {
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.the-b2b-change-password {
  width: 100%;
  padding-top: $space-200;

  @include mediaXs {
    max-width: rem(300);
    padding-top: $space-700;
  }

  &__title {
    text-align: center;
    font-size: 20px;
    font-weight: 300;
    margin: 34px 0;
  }

  /* Actions */
  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: $space-800;
    .btnRcovery {
      padding-left: inherit;
      margin-inline-end: auto;
      background-color: transparent;
    }
  }
  /* Errors */

  ::v-deep .ods-form-item__error {
    margin-bottom: 10px;
  }

  .ods-mb-10 {
    margin-top: 40px;
  }
  /* Register */

  &__register {
    display: flex;
    justify-content: space-between;
    margin-top: $space-400;
    padding-top: $space-400;

    border-top: $border-size-200 dotted var(--color-border-hard-divisor);
    @include txt-body-400;
    text-align: center;

    & > a {
      color: var(--color-txt-interactive);
      margin-left: $space-200;
      transition: 0.3s all ease;

      &:hover {
        color: var(--color-bg-hover);
      }
    }
  }
}
</style>
